export default __webpack_public_path__ + "static/media/logo_otn_market_2@4x.a39cbf97.png";